import intlTelInput from "intl-tel-input"
import { NSerializeJson } from "nserializejson"

export class ValidateForm {
  constructor() {
    this.initForms()
  }

  initForms() {
    document.querySelectorAll(".contact-form").forEach((form) => {
      const formBtn = form.querySelector(".form-btn")
      const nameInput = form.querySelector(".name_input")
      const emailInput = form.querySelector(".email_input")
      const phoneInput = form.querySelector("input[type='tel']")
      const checkboxInput = form.querySelector(".checkbox")

      const nameError = form.querySelector(".name-error")
      const emailError = form.querySelector(".email-error")
      const phoneError = form.querySelector(".phone-error")
      const alertIconName = form.querySelector(".alert-name__image")
      const alertIconEmail = form.querySelector(".alert-email__image")
      const alertIconPhone = form.querySelector(".alert-phone__image")

      formBtn.disabled = true

      let iti
      let valid_iti = false
      if (phoneInput) {
        if(document.body.getAttribute('data-country') === 'UA') {
          iti = intlTelInput(phoneInput, {
            initialCountry: "UA",
            separateDialCode: true,
          })
        } else {
          iti = intlTelInput(phoneInput, {
            // loadUtils: () => import("intl-tel-input/utils"),
            loadUtils: () => import("../utils/iti-utils.js"),
            initialCountry: "auto",
            geoIpLookup: (callback) => {
              fetch("https://ipapi.co/json")
                .then((res) => res.json())
                .then((data) => callback(data.country_code))
                .then(() => valid_iti = true)
                .catch(() => callback("UA"))
            },
            separateDialCode: true,
            strictMode: true,
          })
        }
      }

      function resetErrors() {
        if (nameError) nameError.classList.add("hide")
        if (emailError) emailError.classList.add("hide")
        if (phoneError) phoneError.classList.add("hide")

        if (nameInput) nameInput.classList.remove("error")
        if (emailInput) emailInput.classList.remove("error")
        if (phoneInput) phoneInput.classList.remove("error")
        if (checkboxInput) checkboxInput.classList.remove("error")

        if (alertIconName) alertIconName.classList.add("hide")
        if (alertIconEmail) alertIconEmail.classList.add("hide")
        if (alertIconPhone) alertIconPhone.classList.add("hide")
      }

      function validateForm() {
        let isValid = true
        resetErrors()
        if (nameInput && (nameInput.value.trim().length < 3 || nameInput.value.trim().length > 30)) {
          nameError.classList.remove("hide")
          nameInput.classList.add("error")
          alertIconName.classList.remove("hide")
          isValid = false
        }

        if (
          emailInput &&
          emailInput.value.trim() &&
          !/\S+@\S+\.\S+/.test(emailInput.value.trim())
        ) {
          emailError.classList.remove("hide")
          emailInput.classList.add("error")
          alertIconEmail.classList.remove("hide")
          isValid = false
        }

        if (phoneInput && phoneInput.value.trim().length > 0) {
          if (valid_iti) {
            if (iti && iti.isValidNumber()) {
              phoneError.classList.add("hide")
              phoneInput.classList.remove("error")
              alertIconPhone.classList.add("hide")
            } else {
              phoneError.classList.remove("hide")
              phoneInput.classList.add("error")
              alertIconPhone.classList.remove("hide")
              isValid = false
            }
          } else {
            if (iti && phoneInput.value.trim().length > 7) {
              phoneError.classList.add("hide")
              phoneInput.classList.remove("error")
              alertIconPhone.classList.add("hide")
            } else {
              phoneError.classList.remove("hide")
              phoneInput.classList.add("error")
              alertIconPhone.classList.remove("hide")
              isValid = false
            }
          }
        }

        if (checkboxInput && !checkboxInput.checked) {
          checkboxInput.classList.add("error")
          isValid = false
        }

        formBtn.disabled =
          !isValid ||
          (nameInput && nameInput.value.trim().length === 0) ||
          (emailInput && emailInput.value.trim().length === 0) ||
          (phoneInput && phoneInput.value.trim().length === 0) ||
          (checkboxInput && checkboxInput.required && !checkboxInput.checked)
      }

      if (nameInput) {
        nameInput.addEventListener("input", () => {
          if (nameInput.value.trim().length >= 3) {
            nameError.classList.add("hide")
            nameInput.classList.remove("error")
          } else if (nameInput.value.trim().length > 0) {
            nameError.classList.remove("hide")
            nameInput.classList.add("error")
          }
          validateForm()
        })
      }

      if (emailInput) {
        emailInput.addEventListener("input", () => {
          if (/\S+@\S+\.\S+/.test(emailInput.value.trim())) {
            emailError.classList.add("hide")
            emailInput.classList.remove("error")
            alertIconEmail.classList.add("hide")
          } else if (emailInput.value.trim().length > 0) {
            emailError.classList.remove("hide")
            emailInput.classList.add("error")
            alertIconEmail.classList.remove("hide")
          }
          validateForm()
        })
      }

      if (phoneInput) {
        phoneInput.addEventListener("input", () => {
          if (phoneInput.value.trim().length > 0 && iti && iti.isValidNumber()) {
            phoneError.classList.add("hide")
            phoneInput.classList.remove("error")
            alertIconPhone.classList.add("hide")
          } else {
            phoneError.classList.remove("hide")
            phoneInput.classList.add("error")
            alertIconPhone.classList.remove("hide")
          }
          validateForm()
        })
      }

      if (checkboxInput) {
        checkboxInput.addEventListener("change", () => {
          validateForm()
        })
      }

      if (form) {
        form.addEventListener("submit", async (e) => {
          e.preventDefault()
          validateForm()

          if (!formBtn.disabled) {
            const succesfullRequest = document.querySelector(
              `[data-success='${form.getAttribute("data-success-modal") || "success_modal"}']`,
            )
            const BadRequest = document.querySelector(
              `[data-success='${form.getAttribute("data-error-modal") || "error_modal"}']`,
            )

            formBtn.disabled = true

            const formDataObject =
              form.type === "json"
                ? JSON.stringify(NSerializeJson.serializeForm(form))
                : new FormData(form)

            if (iti) {
              const countryData = iti.getSelectedCountryData()
              if (form.type === "json") {
                formDataObject.phone_country_dial_code = countryData.dialCode
                formDataObject.phone_country_iso = countryData.iso2
              } else {
                formDataObject.append("phone_country_dial_code", countryData.dialCode)
                formDataObject.append("phone_country_iso", countryData.iso2)
              }
            }

            try {
              let form_options = {
                method: form.method || "post",
                headers:
                  form.type === "json"
                    ? {
                      "Content-Type": "application/json",
                      "X-CSRF-TOKEN":
                          document
                            .querySelector("meta[name=\"csrf-token\"]")
                            ?.getAttribute("content") || "",
                    }
                    : {
                      "X-CSRF-TOKEN":
                          document
                            .querySelector("meta[name=\"csrf-token\"]")
                            ?.getAttribute("content") || "",
                    },
                body: formDataObject,
              }

              const response = await fetch(form.action, form_options)

              if (response.status !== 200) {
                BadRequest && BadRequest.classList.add("openRequest")
                return
              }
              succesfullRequest.classList.add("openRequest")

              if (form.getAttribute("data-lock")) {
                document.body.classList.add("lock")
              }

              window.dataLayer = window.dataLayer || []

              window.dataLayer.push({
                event: form.getAttribute("data-layer-push") || "macro_form_submit_unique",
              })

              console.info("Request is success")
              form.reset()
            } catch (error) {
              console.error("Request failed", error)
            }
          }
        })
      }

      validateForm()
    })

    const closeFormBtns = document.querySelectorAll(".close-btn")

    closeFormBtns.forEach((closeBtn) => {
      closeBtn.addEventListener("click", () => {
        document.querySelector(".openRequest") &&
          document.querySelector(".openRequest").classList.remove("openRequest")
        document.body.classList.remove("lock")
      })
    })
  }
}
